module.exports = __webpack_public_path__ + "media/steps/meet_getauto_bcg@2x-a21fe4ef.png";